import { render, staticRenderFns } from "./MenuMovilComponent.vue?vue&type=template&id=c5a0530a"
import script from "./MenuMovilComponent.vue?vue&type=script&lang=js"
export * from "./MenuMovilComponent.vue?vue&type=script&lang=js"
import style0 from "./MenuMovilComponent.vue?vue&type=style&index=0&id=c5a0530a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports